"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrowRight = exports.iconName = exports.paths = void 0;
exports.paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "m20.0008 12.0001-8-8.001-1.4143 1.414L16.1727 11H4v2h12.1723l-5.5868 5.5866 1.4141 1.4142 8.0012-8.0007z" } }];
exports.iconName = 'arrow-right';
exports.arrowRight = { iconName: exports.iconName, paths: exports.paths };
exports.default = exports.paths;
